export enum OktaGroups {
  BUXTONCORP = "BuxtonCorp",
  MULTIACCOUNTUSERS = "MultiAccountUsers",
  BuxtonSales = "BuxtonSales",
};